module.exports = __webpack_public_path__ + "static/media/warning-alert.f14277e5.svg";